import React, { useState, useEffect } from 'react'
import {useParams} from 'react-router-dom'
import {useSelector, useDispatch} from 'react-redux'

import CommentForm from './CommentForm'
import CommentBubble from './CommentBubble'
import useEmoji from '../hooks/useEmoji'
import getPersonDetails from '../actions/getPersonDetails'

function PersonDetails(props){
    const [comments, setComments] = useState([])
    const person = useSelector(state => state.person)
    const params = useParams()  
    const dispatch = useDispatch()  

    useEffect(()=>{
        dispatch(getPersonDetails(params.id))
    },[params.id])

    const addComment = (comment) => {
        setComments([...comments, comment])   
    }

    return (
        <div style={{heigth : 100 + 'vh'}} className="mt-3 p-5 border shadow h-100 bg-white rounded">
            <div className="container">
                <div className="row">
                    <div className="col-12 mx-auto">
                        <h1>{person.name}</h1>
                        <h2>{person.role}</h2>
                        <h4 className="mt-4">Blood Status : {person.bloodStatus}</h4>
                        <h4 className="mt-4">Organizations :</h4>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Ministry of Magic</th>
                                    <th>Order Of The Phoenix</th>
                                    <th>Dumbledores Army</th>
                                    <th>Death Eater</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{useEmoji(person.ministryOfMagic)}</td>
                                    <td>{useEmoji(person.orderOfThePhoenix)}</td>
                                    <td>{useEmoji(person.dumbledoresArmy)}</td>
                                    <td>{useEmoji(person.deathEater)}</td>
                                </tr>
                            </tbody>
                        </table>
                        <CommentForm addComment={addComment}/>
                        {comments.map((comment)=>{
                            return (
                                <CommentBubble comment={comment}/>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PersonDetails